<template>
	<div class="home-ai">
		<header class="fade-in-bottom-small">
			<img src="@/assets/img-pc/88.png" alt="">
			<span class="theme-color">AI</span>
			Quantitative Strategy
		</header>
		<ul class="noselector">
			<li v-for="item in data" :key="item.id">
				<p>
					<img alt="" :src="items" v-for="(items, index) in item.images" :key="index" class="lazy-img coin1"
						:class="[index > 0 ? 'coin2' : '']">
					<span class="name">{{ item.invest }}</span>
				</p>
				<img :src="item.ai_pc_image" alt="" class="line">
				<div>
					<span class="left">
						<span>{{ $t('最大收益率') }}</span>
						<span class="theme-color">{{ item.rate }}%</span>
					</span>
					<span class="middle">
						<img src="@/assets/img-pc/2.1a27bfae.gif" alt="" class="ball-gif">
						<img src="@/assets/img-pc/91.ac0e818c.png" alt="" class="ball-png">
					</span>
					<span class="right">
						<span>{{ $t('参与人数') }}</span>
						<span class="count">{{ item.count }}</span>
					</span>
				</div>
			</li>
		</ul>
		<button class="cm-btn-animation1" @click="$nav.go('/pc/aiIndex')">
			<span>{{ $t('了解AI量化投资') }}</span>
			<img src="@/assets/img-pc/33.5a9cc0e8.svg">
		</button>
	</div>
</template>
<script>
export default {
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	components: {},
	data() {
		return {};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.home-ai {
	margin: 120px auto 140px;

	.cm-btn-animation1 {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 200px;
		height: 44px;
		padding: 14px 60px;
		border: 1px solid #333;
		background-color: #000;
		color: #fff;
		font-size: 18px;
		border-radius: 24px;
		margin: 20px auto 0;
		cursor: pointer;
		overflow: hidden;
		min-width: 268px;
		margin: 20px auto 0;

		img {
			transition: all .2s;
			margin-left: 15px;
		}
	}

	.noselector {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		// justify-content: space-between;
		scrollbar-width: none;
		list-style: none;

		li {
			flex: none;
			width: calc(33.33333% - 20px);
			height: 238px;
			margin-bottom: 30px;
			background-image: url('~@/assets/img-pc/home_bj2.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 20px 0;
			cursor: pointer;
			transition: all .2s;

			&:nth-of-type(3n-1) {
				margin-left: 30px;
				margin-right: 30px;
			}

			>div {
				width: 360px;
				height: 58px;
				background-image: url('~@/assets/img-pc/home_bj3.png');
				background-size: 100% 100%;
				background-repeat: no-repeat;
				display: flex;
				align-items: center;
				padding: 0 20px;

				.right {
					flex: 1;
					display: inline-flex;
					flex-direction: column;
					align-items: flex-end;
					color: #fff;

					span {
						font-size: 12px;
					}

					.count {
						font-size: 16px;
					}
				}

				.middle {
					width: 80px;
					height: 80px;
					position: relative;
					display: flex;
					align-items: center;
					justify-content: center;

					.ball-png {
						flex: none;
						width: 100%;
						height: 100%;
						position: absolute;
						z-index: 1;
						top: 0;
						left: 0;
					}

					.ball-gif {
						border-radius: 50%;
						flex: none;
						width: 52px;
						height: 52px;
						position: relative;
						z-index: 2;
					}
				}

				.left {
					flex: 1;
					display: inline-flex;
					flex-direction: column;
					color: #fff;

					span {
						font-size: 12px;
					}

					.theme-color {
						color: #00f0ff !important;
						font-size: 16px;
					}
				}
			}

			.line {
				width: 390px;
				height: 76px;
				margin-bottom: 11px;
			}

			p {
				width: 100%;
				height: 40px;
				padding: 0 20px;
				display: flex;
				align-items: center;
				margin-bottom: 14px;

				.lazy-img {
					width: 40px;
					height: 40px;
					margin: 0;

					&.coin2 {
						margin-left: -12px;
					}
				}

				.name {
					font-size: 18px;
					margin-left: 8px;
					color: #fff;
				}
			}
		}
	}

	.fade-in-bottom-small {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 50px;
		line-height: 60px;
		margin-bottom: 90px;
		color: #fff;

		img {
			width: 100px;
			height: 100px;
			margin-right: 26px;
		}

		.theme-color {
			margin-right: 10px;
			color: #00f0ff !important;
		}
	}
}
</style>